import React from 'react'

const IconFont = ({ style = {}, ...props }) => {
  return (
    <svg
      width="30"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M23.897 4.438a2.025 2.025 0 0 0-3.75 0l-1.125 2.718 1.687 3.985 1.322-3.188 1.64 3.984h-2.643l1.266 2.991h2.634l1.106 2.634c.254.58.83.95 1.463.938a1.528 1.528 0 0 0 1.565-1.566c0-.487-4.978-12.046-5.165-12.496zm-9.919-1.97a2.972 2.972 0 0 0-5.466 0C.77 20.779.937 20.095.937 20.807a2.24 2.24 0 0 0 2.297 2.297 2.306 2.306 0 0 0 2.157-1.416l1.621-3.89h8.438l1.631 3.91a2.297 2.297 0 0 0 2.147 1.396 2.24 2.24 0 0 0 2.334-2.297c0-.712.16-.065-7.584-18.337zM8.841 13.41l2.409-5.793 2.41 5.793H8.84z"
        fill="#77CA34"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default IconFont
